import React, { FC, useEffect, useRef, useState } from 'react';
import { myInfoDataStore } from 'src/store/myInfo';
import { fetchUpdateMyInfoData } from 'src/fetch/stepA';
import { useQueryClient } from '@tanstack/react-query';
import _ from 'lodash';
import { getMemberInfo } from 'src/utils/common';
import { validateRRN } from 'src/utils/charSet';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import MainBox from 'src/components/molecules/contentLayout/MainBox';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import MyInfo from 'src/components/organisms/template/StepA/MyInfo';
import MyFamilyInfo from 'src/components/organisms/template/StepA/MyFamilyInfo';
import './style.scss';

interface Props {
  num: number;
}

const StepA: FC<Props> = ({ num }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);

  const [myInfoTypeState, setMyInfoTypeState] = useState({ type: '' });
  const myInfoDataStateResult = myInfoDataStore((state: any) => state.result);
  const orgData = myInfoDataStore((state: any) => state.origin).data;

  const myInfoInitState = myInfoDataStore((state: any) => state.init);
  const myInfoDataStateParam = myInfoDataStore((state: any) => state.param);
  const myInfoDataStateBindParam = myInfoDataStore((state: any) => state.bindParam);

  const confirmEvt = () => {
    console.log('CONFIRM!');
  };
  const editClickEvt = (type: string) => {
    if (type === 'save') {
      const userData = myInfoDataStateResult.data;
      const param: any = {};
      param.start_date = userData.start_date.replaceAll('.', '');
      param.end_date = userData.end_date.replaceAll('.', '');
      param.add = userData.add;
      param.email = userData.email;
      param.cel_number = userData.cel_number;
      param.tel_1 = userData.tel_1;
      param.name = userData.name;
      param.acct_year = userInfoData.acct_year;
      param.co_cd = userInfoData.co_cd;
      param.co_id = userInfoData.co_id;
      fetchUpdateMyInfoData(param, queryClient, errorModalState, loadingState, () => {
        const initialSeq = myInfoDataStateParam.initialSeq || 0;
        myInfoDataStateBindParam({ initialSeq: initialSeq + 1 });
      });
    }
    if (type === 'cancle') {
      myInfoInitState({ data: orgData });
    }
    setMyInfoTypeState({ type: type });
  };

  const middleContent = () => {
    return (
      <div className="_temp_content_layout">
        <div className="_info_step">
          <section className="_section_layout">
            <TitleContent
              label="본인정보"
              vtype="t2"
              content={<MyInfo viewType={myInfoTypeState.type} />}
              editClickEvt={editClickEvt}
            />
          </section>
          <section className="_section_layout">
            <TitleContent label="부양가족 정보" vtype="t2" content={<MyFamilyInfo />} />
          </section>
        </div>
      </div>
    );
  };
  return (
    <MainBox
      label="가족정보"
      icon="ri-parent-line"
      desc=<div>
        연말정산 대상 가족정보를 확인하시고, 배우자·자녀·부모 등 부양가족의 추가, 삭제 또는 정보
        변경이 있는 경우
        <br /> 관련 증빙서류와 함께 기한 내 수정 신청해 주시기 바랍니다.
        <br /> 가족정보가 실제와 다를 경우 연말정산 공제에 영향을 받을 수 있습니다.
      </div>
      content={middleContent()}
      num={num}
      confitmEvent={confirmEvt}
      viewType="slide"
    />
  );
};

export default StepA;
